// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Title_wrapper__1DsLK","background":"Title_background__3s58B"};